import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import UILabel from "UIComponents/UILabel";
import UIBaseComponent from "UIComponents/UIBaseComponent";

class IBReflection extends UIBaseComponent {
  constructor(props) {
    super(props);
  }

  renderEdit = () => {
    return null;
  };

  getLabel = () => {
    const { label, isRequired, showErrorText } = this.props;
    return `${label}${(isRequired || showErrorText) && !!label ? `*` : ``}`;
  };

  renderLabel = () => {
    const {
      label,
      subText,
      prompts,
      userType,
      labelStyle,
      subTextStyle,
      labelComponent,
      labelContainerStyle,
    } = this.props;

    return _.isEqual(userType, "staff") ? (
      <UILabel
        label={this.getLabel()}
        subText={subText}
        labelComponent={labelComponent}
        labelStyle={labelStyle}
        labelContainerStyle={labelContainerStyle}
        subTextStyle={subTextStyle}
      />
    ) : (
      <UILabel
        label={label}
        subText={prompts}
        labelStyle={labelStyle}
        labelContainerStyle={labelContainerStyle}
        subTextStyle={subTextStyle}
      />
    );
  };

  shouldShowViewEmpty = () => {
    const { responses } = this.props;

    return _.get(responses, "totalCount", 0) == 0;
  };
}

const mapStateToProps = (state, ownProps) => {
  const { t, isSinglePageAndNewUnitView } = ownProps;
  const userType = _.get(state, "login.userInfo.user_type");

  const isParentOrStudent = _.includes(["parent", "student"], userType);
  const emptyText =
    userType === "staff" || (isSinglePageAndNewUnitView && isParentOrStudent)
      ? ownProps.emptyText
      : t("common:content_not_accessible_by_student_and_family");

  return {
    userType,
    emptyText,
  };
};

const IBReflectionWrapper = connect(mapStateToProps, null)(IBReflection);

export default IBReflectionWrapper;
